/** DataBest — Backlog + Alerts API. */
import api from "@/lib/axios";

export const backlogApi = {
    list: (params) => api.get("/backlog", { params }).then((r) => r.data),
    summary: () => api.get("/backlog/summary").then((r) => r.data),
};
